import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const AccordionHeaderTextWrapper = styled.div`
  padding: 10px 16px;
  display: grid;
  align-items: center;

  ${responsive.MOBILE`
    padding: 10px 8px;
  `}
  .accordion-header-form-header-left {
    color: ${COLORS.cirrus_black10};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const AccordionHeaderWrapper = styled.div`
  .MuiPaper-elevation {
    border-radius: 0px;
    box-shadow: none;
  }

  .MuiAccordionDetails-root {
    padding: 0px;
  }

  .MuiAccordionSummary-root {
    background-color: ${COLORS.primary_light_blue2};
    min-height: 40px;
    height: 40px;
    padding-left: 0px;
    box-shadow: none;
    border: none;

    &.Mui-expanded {
      min-height: 40px;
      height: 40px;
    }

    .MuiAccordionSummary-expandIconWrapper {
      margin-top: 5px;
    }
  }

  .accordion-title {
    width: 100%;
    cursor: auto;

    ${responsive.MOBILE`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
  }

  .accordion-error-icon {
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    margin-left: 16px;

    ${responsive.MOBILE`
      margin-left: 8px;
    `}

    svg {
      width: 16px;
      height: 14px;
      color: ${COLORS.cirrus_red};
    }
  }

  .container-no-accordion {
    background-color: ${COLORS.cirrus_white};
  }

  .no-accordion-title {
    width: 100%;
    cursor: auto;
    background-color: ${COLORS.primary_light_blue2};
  }
`;
